import { isEnvFlagOn } from '@/env';

/**
 * Whether the panel offers email + password next to Google on `/login` and `/registro`.
 *
 * Product decision (Johan, 2026-10-19): the depósito panel signs in with Google only. The email +
 * password flow (sign-in, sign-up, email verification, password reset — `useAuth.tsx`,
 * `Login.tsx`, `RegistroPage.tsx`) stays in the code and keeps its tests; it is only hidden. Set
 * `VITE_EMAIL_PASSWORD_AUTH=true` to show it again.
 */
export function isEmailPasswordAuthEnabled(): boolean {
  return isEnvFlagOn('VITE_EMAIL_PASSWORD_AUTH');
}
